import { PlusIcon } from "@xola/icons";
import { PopoverList } from "@xola/ui-kit";
import { orderBy } from "lodash";
import React from "react";
import { CatalogItemObject, CatalogType, EquipmentCatalogItem, UnitType } from "types";
import { useVisibility } from "../../../hooks/useVisibility";
import { NoTranslate } from "../../Common/NoTranslate";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { useEquipmentResourcesWithTemplates } from "@/hooks/resources/useEquipmentResourcesWithTemplates";

interface AddEquipmentPopoverProps {
    onInsert: (catalogItem: EquipmentCatalogItem) => void;
}

export const AddEquipmentPopover = ({ onInsert }: AddEquipmentPopoverProps) => {
    const [visible, { show, hide }] = useVisibility(false);
    const equipmentResourcesWithTemplates = orderBy(useEquipmentResourcesWithTemplates(), [
        (resource) => resource.name.toLowerCase(),
    ]);

    const handleInsert = (resource: { id: string; name: string; templateId: string }) => {
        const catalogItem: EquipmentCatalogItem = {
            name: resource.name,
            unitType: UnitType.EQUIPMENT,
            type: CatalogType.QUANTITY,
            object: CatalogItemObject.EQUIPMENT_CATALOG_ITEM,
            template: { id: resource.templateId } as any,
        } as EquipmentCatalogItem;

        onInsert(catalogItem);
        hide();
    };

    return (
        <PopoverList visible={visible} className="max-h-96 w-75 overflow-y-scroll" onClickOutside={hide}>
            <SecondaryButton size="small" icon={<PlusIcon />} onClick={visible ? hide : show}>
                Add Equipment
            </SecondaryButton>

            {equipmentResourcesWithTemplates.map((resource) => (
                <PopoverList.Item key={resource.id} name={resource.name} onClickItem={() => handleInsert(resource)}>
                    <NoTranslate>{resource.name}</NoTranslate>
                </PopoverList.Item>
            ))}
        </PopoverList>
    );
};
